import React from "react";
import { Modal } from "../core/Modal/Modal";
import { Button } from "../core/Button/Button";
import {
  DELETE_CERTIFICATE_LABEL,
  EMPTY_CERTIFICATIONS_MESSAGE,
} from "../../constants/Dictionary";
import { BodyTyp } from "../Typography/Typography";
import { FontWeightEnum } from "../../types/AppTypes";
import { PDFViewer } from "../PdfViewer/PdfViewer";
import { ReactComponent as BinIcon } from "../../icons/bin.svg";
import { Loader } from "../core/Loader/Loader";
import { useCertificateModal } from "../../hooks/certificateModal.hook";

type CertificateModalProps = {
  isOpen: boolean;
  closeModal: () => void;
  onDelete?: () => void;
  label: string;
  certificateApi?: () => Promise<ArrayBuffer>;
  idKeyApi?: string;
};

export const CertificateModal = ({
  isOpen,
  closeModal,
  onDelete,
  label,
  certificateApi,
  idKeyApi,
}: CertificateModalProps) => {
  const { data, isLoading } = useCertificateModal({
    idKeyApi,
    certificateApi,
    isOpen,
  });

  return (
    <Modal
      isOpen={isOpen}
      closeModal={closeModal}
      label={label}
      rightButton={
        onDelete && (
          <Button
            label={DELETE_CERTIFICATE_LABEL}
            onClick={onDelete}
            icon={<BinIcon />}
          />
        )
      }
    >
      {isLoading ? (
        <Loader loading={isLoading} size={18} />
      ) : data ? (
        <PDFViewer file={data.slice(0)} />
      ) : (
        <BodyTyp variant="2" fontWeight={FontWeightEnum.REGULAR}>
          {EMPTY_CERTIFICATIONS_MESSAGE}
        </BodyTyp>
      )}
    </Modal>
  );
};
